import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './services/auth-guard.service';

// Import Containers
import {
    FullLayout,
    SimpleLayout
} from './containers';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'pages/login',
        pathMatch: 'full'
    },
    {
        path: '',
        component: FullLayout,
        data: {
            title: 'Home'
        },
        canActivate: [AuthGuard],
        children: [
            {
                path: 'dashboard',
                loadChildren: './views/dashboard/dashboard.module#DashboardModule'
            },
            {
                path: 'cadastros',
                loadChildren: './views/cadastros/cadastros.module#CadastrosModule'
            },
            {
                path: 'uploads',
                loadChildren: './views/uploads/uploads.module#UploadsModule'
            },
            {
                path: 'auditor',
                loadChildren: './views/auditor/auditor.module#AuditorModule'
            },
            {
                path: 'auditoria',
                loadChildren: './views/auditoria/auditoria.module#AuditoriaModule'
            },
            {
                path: 'fornecedor',
                loadChildren: './views/fornecedor/fornecedor.module#FornecedorModule'
            },
            {
                path: 'agenda-cadastros',
                loadChildren: './views/agenda-cadastros/agenda-cadastros.module#AgendaCadastrosModule'
            },
            {
                path: 'solicitacao',
                loadChildren: './views/solicitacao/solicitacao.module#SolicitacaoModule'
            },
            {
                path: 'perfil',
                loadChildren: './views/perfil/perfil.module#PerfilModule'
            },
            {
                path: 'certificado',
                loadChildren: './views/certificado/certificado.module#CertificadoModule'
            },
            {
                path: 'processos',
                loadChildren: './views/processos/processos.module#ProcessosModule'
            },
            {
                path: 'relatorios',
                loadChildren: './views/relatorios/relatorios.module#RelatoriosModule'
            }
        ]
    },
    {
        path: 'pages',
        component: SimpleLayout,
        data: {
            title: 'Pages'
        },
        children: [
            {
                path: '',
                loadChildren: './views/pages/pages.module#PagesModule',
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [AuthGuard]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /app/src/app/app.routing.ts